import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import schema from './schema';
import View from './View';
import BlockImageInput from '../../helpers/BlockImageInput/BlockImageInput';

const Edit = (props: any) => {
  const {
    onChangeBlock,
    data,
    block,
    selected,
    navRoot,
    contentType,
    blocksErrors,
  } = props;
  const blockSchema = schema(props);

  const imageSlot = ({ fieldId, index, value, element }: any) => {
    if (fieldId !== 'images' || typeof index !== 'number') return undefined;
    return (
      <BlockImageInput
        id={`images-${index}-image`}
        block={block}
        value={value}
        imageSize="preview"
        onChange={(next) => {
          const images = [...(data.images || [])];
          images[index] = { ...images[index], image: next };
          onChangeBlock(block, { ...data, images });
        }}
      >
        {element}
      </BlockImageInput>
    );
  };

  return (
    <>
      <View {...props} isEditMode imageSlot={imageSlot} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={blockSchema}
          title={blockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
